import html from '../../assets/images/skills/html.webp';
import css from '../../assets/images/skills/css.webp';
import js from '../../assets/images/skills/js.webp';
import php from '../../assets/images/skills/php.webp';
import git from '../../assets/images/skills/git.webp';
import laravel from '../../assets/images/skills/laravel.webp';
import reactjs from '../../assets/images/skills/reactjs.webp';
import nodejs from '../../assets/images/skills/nodejs.webp';
import bootstrap from '../../assets/images/skills/bootstrap.webp';
import tailwind from '../../assets/images/skills/tailwind.webp';
import mysql from '../../assets/images/skills/mysql.webp';
import mariadb from '../../assets/images/skills/mariadb.webp';
import figma from '../../assets/images/skills/figma.webp';


const response =  {
    "status": 200,
    "message": "OK",
    "data": [
        {
            "id": 1,
            "icon": html,
            "name": "HTML",
            "experience": "3 Years",
        },
        {
            "id": 2,
            "icon": css,
            "name": "CSS",
            "experience": "3 Years",
        },
        {
            "id": 3,
            "icon": js,
            "name": "Javascript",
            "experience": "3 Years",
        },
        {
            "id": 4,
            "icon": php,
            "name": "PHP",
            "experience": "3 Years",
        },
        {
            "id": 5,
            "icon": git,
            "name": "GIT",
            "experience": "3 Years",
        },
        {
            "id": 6,
            "icon": laravel,
            "name": "Laravel",
            "experience": "2 Years",
        },
        {
            "id": 7,
            "icon": reactjs,
            "name": "React Js",
            "experience": "2 Years",
        },
        {
            "id": 8,
            "icon": nodejs,
            "name": "Node Js",
            "experience": "6 Months",
        },
        {
            "id": 9,
            "icon": bootstrap,
            "name": "Bootstrap",
            "experience": "3 Years",
        },
        {
            "id": 10,
            "icon": tailwind,
            "name": "Tailwind CSS",
            "experience": "3 Months",
        },
        {
            "id": 11,
            "icon": mysql,
            "name": "MySQL",
            "experience": "3 Years",
        },
        {
            "id": 12,
            "icon": mariadb,
            "name": "MariaDB",
            "experience": "3 Years",
        },
        {
            "id": 13,
            "icon": figma,
            "name": "Figma",
            "experience": "3 Years",
        },
    ]
}

export default response;